
export default function AmenitiesSection() {
  const amenities = [
    { icon: 'ri-building-4-line', label: 'Restrooms', count: '60+' },
    { icon: 'ri-parking-box-line', label: 'Free Parking', count: '45+' },
    { icon: 'ri-drop-line', label: 'Water Fountains', count: '80+' },
    { icon: 'ri-restaurant-line', label: 'Picnic Areas', count: '55+' },
    { icon: 'ri-fire-line', label: 'BBQ Grills', count: '30+' },
    { icon: 'ri-riding-line', label: 'Bike Racks', count: '40+' },
    { icon: 'ri-wheelchair-line', label: 'ADA Accessible', count: '50+' },
    { icon: 'ri-flashlight-line', label: 'Lighted Paths', count: '25+' },
  ];

  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Left - Info */}
          <div className="bg-gradient-to-br from-emerald-600 to-teal-700 rounded-2xl p-10 text-white">
            <div className="inline-flex items-center gap-2 bg-white/15 px-3 py-1 rounded-full mb-4">
              <i className="ri-wheelchair-line text-sm"></i>
              <span className="text-xs font-semibold">Accessible for Everyone</span>
            </div>
            <h2 className="text-3xl font-bold mb-4">Inclusive Parks for All Residents</h2>
            <p className="text-white/80 mb-6 leading-relaxed">
              Roseville is committed to providing accessible, safe, and enjoyable outdoor spaces for residents of all ages and
              abilities. Our parks feature ADA-compliant pathways, accessible restrooms, and inclusive playground equipment.
            </p>
            <ul className="space-y-3 mb-8">
              {[
                'ADA-compliant pathways & ramps',
                'Accessible restrooms at major parks',
                'Inclusive playground equipment',
                'Reserved accessible parking',
                'Sensory-friendly play areas',
              ].map((item) => (
                <li key={item} className="flex items-center gap-3 text-sm">
                  <div className="w-5 h-5 flex items-center justify-center bg-white/20 rounded-full flex-shrink-0">
                    <i className="ri-check-line text-xs"></i>
                  </div>
                  {item}
                </li>
              ))}
            </ul>
            <a
              href="https://www.roseville.ca.us/government/departments/parks_recreation_libraries"
              target="_blank"
              rel="noopener noreferrer nofollow"
              className="inline-flex items-center gap-2 bg-white text-emerald-700 px-6 py-2.5 rounded-full font-semibold text-sm hover:bg-gray-100 transition-colors whitespace-nowrap cursor-pointer"
            >
              Learn More <i className="ri-arrow-right-line"></i>
            </a>
          </div>

          {/* Right - Amenity Grid */}
          <div>
            <h3 className="text-xl font-bold text-gray-900 mb-6">Park Amenities Across Roseville</h3>
            <div className="grid grid-cols-2 gap-4">
              {amenities.map((a) => (
                <div
                  key={a.label}
                  className="bg-white rounded-xl p-5 border border-gray-100 hover:shadow-md transition-all group cursor-default"
                >
                  <div className="flex items-center gap-4">
                    <div className="w-12 h-12 flex items-center justify-center bg-emerald-50 rounded-xl group-hover:bg-emerald-100 transition-colors">
                      <i className={`${a.icon} text-emerald-600 text-xl`}></i>
                    </div>
                    <div>
                      <div className="text-lg font-bold text-gray-900">{a.count}</div>
                      <div className="text-sm text-gray-500">{a.label}</div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
